import React from "react";
import getConfig from "next/config";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const PromoBanner = ({ small, medium, large }) => {
  if (small && medium) {
    return (
      <>
        <img src={`${settings.cdn}${small}`} className="sm:hidden" alt="" />

        <img
          src={`${settings.cdn}${medium}`}
          className="hidden sm:block lg:hidden"
          alt=""
        />

        <img
          src={`${settings.cdn}${large}`}
          className="hidden lg:block"
          alt=""
        />
      </>
    );
  }

  return <img src={`${settings.cdn}${large}`} alt="" />;
};

export default PromoBanner;
